import { registerComponent } from '@core/alpine-js';
import postCategories from '../components/blog/post-categories';

registerComponent('postCategories', postCategories);
